import styled from 'styled-components';

export const MetricCard = styled.div`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-md);
  padding: var(--allie-spacing-lg);
  border: 1px solid var(--allie-color-neutral-20);
  border-radius: var(--allie-radius-md);
  background-color: var(--allie-color-white);
`;

export const MetricValueLabel = styled.span`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-xs);
`;

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--allie-spacing-xl);
  container-type: inline-size;
  container-name: metrics-grid;

  @container metrics-grid (max-width: 750px) {
    ${MetricCard} {
      flex-direction: column;
      align-items: flex-start;
    }

    ${MetricValueLabel} {
      text-align: left;
      align-items: flex-start;
    }
  }

  @container metrics-grid (max-width: 450px) {
    ${MetricCard} {
      flex-direction: row;
      align-items: center;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-md);
  container: container / inline-size;

  @container container (max-width: 450px) {
    ${MetricsGrid} {
      grid-template-columns: 1fr;
      gap: var(--allie-spacing-md);
    }
  }
`;

export const MetricIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: var(--allie-radius-md);
  background-color: var(--allie-color-neutral-5);
  color: var(--allie-color-neutral-50);
  font-size: 24px;
`;

export const MetricValue = styled.span`
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  color: var(--allie-color-neutral-90);
  column-gap: var(--allie-spacing-lg);
  flex-wrap: wrap;
`;
